import api from "@utils/api";
const ORGANIZACION = JSON.parse(sessionStorage.getItem("organization"));
export const getOwners = (page, per_page) =>
  api.get(`/owner/organizacion/${ORGANIZACION.organizacion_id}?page=${page}&per_page=${per_page}`);
export const getOwnerById = (id) => api.get(`/owner/${id}`);
export const createOwner = (owner) => api.post("/owner", owner);
export const updateOwner = (id, owner) => api.put(`/owner/${id}`, owner);
export const deleteOwner = (id) => api.delete(`/owner/${id}`);
